/**
 * Formats the Aadhaar value returned by the backend for display.
 *
 * The transaction APIs only return the last four digits of the Aadhaar
 * number (`adhaar_number`). Mask everything except those digits so the
 * value can safely be shown in the UI/export previews.
 *
 * @param {string|number|null|undefined} aadhaarNumber
 * @returns {string}
 */
export const getMaskedAadhaar = (aadhaarNumber) => {
  if (!aadhaarNumber) return "";

  const value = String(aadhaarNumber).trim();
  if (!value) return "";

  // Already masked by the backend or an older API.
  if (/x/i.test(value)) return value;

  const digits = value.replace(/\D/g, "");
  if (!digits) return value;

  return `XXXX XXXX ${digits.slice(-4)}`;
};
